import { UrgentConcernModel } from "app/services/api/types/shiftHandover/models/UrgentConcernModel";
import { UrgentConcernTypeEnum } from "app/services/api/types/shiftHandover/enums/UrgentConcernTypeEnum";

/**
 * Display rule for the reporter of an urgent concern (IC-744).
 *
 * - If `reported_by` is present, show their name.
 * - If `reported_by` is null and the concern is system-generated
 *   (type !== GENERAL), show "System".
 * - If `reported_by` is null and the concern is a general (user-entered)
 *   one, show "Unknown".
 */
export function getUrgentConcernReporterName(
  concern: Pick<UrgentConcernModel, "reported_by" | "type">,
): string {
  if (concern.reported_by?.name) {
    return concern.reported_by.name;
  }
  if (concern.type && concern.type !== UrgentConcernTypeEnum.GENERAL) {
    return "System";
  }
  return "Unknown";
}
